import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-family: "Segoe UI", sans-serif;
    transition: background-color 0.4s ease, color 0.4s ease;
  }

  body {
    background-color: ${({ theme }) => theme.bodyBg};
    color: ${({ theme }) => theme.text};
    transition: background-color 0.4s ease, color 0.4s ease;
  }

  button, input, div {
    transition: background-color 0.4s ease, color 0.4s ease, border 0.4s ease;
  }

   .custom-toast {
    background: #222;
    color: #fff;
    border-left: 5px solid #f97316; 
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    font-weight: bold;
    font-size: 16px;
    border-radius: 10px;
    padding: 16px !important;
    animation: bounce-in 0.4s ease;
    white-space: nowrap;
    width: auto;
  }

  .custom-toast-body {
    margin: 0;
  }

  @keyframes bounce-in {
    0% {
      transform: scale(0.9);
      opacity: 0;
    }
    60% {
      transform: scale(1.05);
      opacity: 1;
    }
    100% {
      transform: scale(1);
    }
  }
`;
